module.exports = __webpack_public_path__ + "static/flags/HO-c161c329bc42131d97a93713919bf49d.gif";